export const toMachineName = (val: string) => {
    return val.toLowerCase()
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
};
export const toSnakeCase = (val: string) => {
    return val.replace(/\W+/g, " ")
      .split(/ |\B(?=[A-Z])/)
      .map(word => word.toLowerCase())
      .join('_');
};
export const toTitleCase = (s: string): string => {
    if (/^[A-Z0-9_]+$/.test(s)) {
        return s
            .split('_')
            .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
            .join(' ');
    }
    return s
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (c: string) => c.toUpperCase())
        .replace(/\s+/g, ' ')
        .trim();
};
